export default __webpack_public_path__ + "static/media/success.c97253c6.gif";